import React from 'react';
import {Badge} from "@material-ui/core";
import Button from "@material-ui/core/Button";

const StatusButton = (props) => {
    const {text, count, onClick} = props

    return (
        <Button onClick={onClick} variant={'outlined'} size={'large'}>
            <Badge badgeContent={count}>
                {text}
            </Badge>
        </Button>
    );
};

export default StatusButton;